import { css } from '@linaria/core';
import { Root as ButtonRoot } from '../Button/styles';
import { Root as ImageRoot } from '../Image/styles';
import media from '../primitives/Media';
import { BottomArea, Info, LegacyTeaserLabel } from './primitives';
const transitionDelay = '1s';
export const TeaserTextRoot = {
    base: css `
		position: relative;

		float: left;

		box-sizing: border-box;
		width: 100%;
		padding: 10px 16px 10px 16px;
	`,
    textPosition: {
        onImage: css `
			position: absolute;
			text-align: left !important;
			opacity: 0;
		`,
        none: css `
			position: absolute;
			text-align: left !important;
			opacity: 0;
		`,
        besideImage: css `
			width: 70%;

			${media('max', 'l')} {
				padding-top: 0;
			}
		`,
        belowImage: null,
    },
    textAlignment: {
        center: css `
			text-align: center;
		`,
        right: css `
			text-align: right;
		`,
        left: null,
        default: null,
    },
    isPictureTeaserType: css `
		padding: 0;
	`,
};
export const ButtonContainer = {
    base: css `
		bottom: 0;

		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		box-sizing: border-box;
		width: 100%;
		padding: 0 16px 10px 16px;

		transition: all 0ms;

		> a {
			width: auto !important;
		}

		@media (hover: hover) and (pointer: fine) {
			position: absolute;
			opacity: 0;
		}
	`,
};
export const ImageButtonContainer = {
    base: css `
		display: flex;
		justify-content: Center;
		width: 100%;

		> a {
			width: auto !important;
		}
	`,
};
export const AvailableTime = {
    base: css ``,
    isNotShowingAvailableTime: css `
		@media (hover: hover) and (pointer: fine) {
			position: absolute;
			opacity: 0;
			transition: all 0ms;
		}
	`,
};
export const TopArea = {
    base: css `
		position: absolute;
		top: 0;
		left: 0;

		flex-wrap: wrap;

		box-sizing: border-box;
		width: 100%;
		padding: 5px 5px 20px 5px;

		transition: all 300ms var(--global-ease-in-out);
	`,
};
export const TopAreaBackground = {
    base: css `
		z-index: -1;
		padding: 20px;

		@media (hover: hover) and (pointer: fine) {
			opacity: 0;
			transition: all 150ms var(--global-ease-in-out);
		}
	`,
};
export const OnImageText = {
    base: css `
		--global-text: 255, 255, 255;

		width: 100%;
		transition: all 150ms var(--global-ease-in-out);

		div {
			width: 100%;
			margin: 0;
		}

		h2 {
			/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
			color: #fff !important;
		}
	`,
    hasHiddenTitle: css `
		h2 {
			display: none;
		}
	`,
    textAlignment: {
        left: null,
        right: null,
        center: css `
			text-align: center;
		`,
    },
};
export const TeaserContainer = {
    base: css `
		z-index: 0;
		top: 0;
		left: 0;

		overflow: hidden;

		width: 100%;

		transition:
			width 150ms var(--global-ease-out),
			height 150ms var(--global-ease-out),
			left 150ms var(--global-ease-out),
			top 150ms var(--global-ease-out),
			background 300ms var(--global-ease-out),
			z-index 0ms 150ms var(--global-ease-out),
			transform 150ms;
	`,
    bottomAreaTransparentOnHover: css `
		&.hover {
			.${BottomArea.base} {
				opacity: 0;
			}
		}
	`,
    hoverEffect: {
        scale: css `
			.${ImageRoot.base} {
				> img {
					transition: all 200ms var(--global-ease-in-out);
				}
			}
			&:hover {
				.${ImageRoot.base} {
					> img {
						transform: scale(1.05);
					}
				}
			}

			.${ButtonRoot.base} {
				svg {
					fill: rgb(var(--global-text));
				}
			}

			&.hover {
				z-index: 2;
				top: -15%;
				left: -15%;

				width: 130%;

				background-color: rgb(var(--teaser-color-base-background-hover));
				box-shadow:
					0 3px 6px rgba(var(--teaser-shadow-shadow), 0.16),
					0 3px 6px rgba(var(--teaser-shadow-shadow), 0.23);

				transition: all 300ms var(--global-ease-in-out);
				transition-delay: ${transitionDelay};
				&.left {
					left: 0;
				}
				&.right {
					left: -30%;
				}
				&.bottom {
					top: -40%;
				}

				.${LegacyTeaserLabel.base}, .${ButtonContainer.base}, .${AvailableTime.base}, .${TeaserTextRoot.base} {
					position: relative;
					opacity: 1;
					transition: all 300ms var(--global-ease-out);
					transition-delay: ${transitionDelay};

					svg {
						opacity: 1;
						transition-delay: ${transitionDelay};
					}
				}
				.${TopAreaBackground.base} {
					opacity: 1;
					transition: all 300ms var(--global-ease-out);
					transition-delay: ${transitionDelay};
				}
				.${BottomArea.base} {
					transition: all 300ms var(--global-ease-out);
					transition-delay: ${transitionDelay};
				}
				.${OnImageText.base} {
					opacity: 0;
					transition: all 300ms var(--global-ease-out);
					transition-delay: ${transitionDelay};
				}
				.${Info.base} {
					min-height: 0;
				}
			}
		`,
        default: css `
			.${ImageRoot.base} {
				> img {
					transition: all 200ms var(--global-ease-in-out);
				}
			}
			.${TopAreaBackground.base} {
				display: none;
			}
			&:hover {
				.${ImageRoot.base} {
					> img {
						transform: scale(1.1);
					}
				}
			}
		`,
    },
};
export const Root = {
    base: css `
		position: relative;

		float: left;

		width: 100%;
		height: 100%;

		background: transparent;

		transition: 150ms all var(--global-ease-in-out);

		a {
			z-index: 0;
			float: left;
			width: 100%;
			text-decoration: none;

			&:focus,
			&:focus img {
				outline: 2px solid rgb(var(--teaser-color-base-border-base));
				outline-offset: -2px;
			}
		}
	`,
    textPosition: {
        none: css `
			height: auto;
		`,
        onImage: css `
			height: auto;
		`,
        belowImage: null,
        besideImage: null,
        onImageWithVideoLink: css `
			.${ButtonRoot.base} {
				position: absolute;
				bottom: 0;
			}
		`,
    },
    textAlignment: {
        center: null,
        left: null,
        right: null,
        centerWithVideoLink: css `
			display: flex;
			justify-content: center;
		`,
        rightWithVideoLink: css `
			display: flex;
			justify-content: flex-end;
		`,
    },
    showText: css `
		background: transparent;
	`,
    isLoading: css `
		background: transparent;
	`,
    videoLink: css `
		.${ButtonRoot.base} {
			float: none;
			display: table;

			width: auto;
			margin-bottom: 15px;
			padding: 5px;
			border-radius: 48px;

			text-transform: uppercase;

			svg {
				width: 1.5rem;
				height: 1.5rem;
			}

			span {
				height: 1.5rem;
			}
		}
	`,
};
export const TeaserWrapper = {
    base: css `
		position: relative;
		float: left;
		width: 100%;
	`,
    expired: css `
		filter: blur(2px);
	`,
};
export const LinkList = {
    base: css `
		position: relative;

		float: left;

		box-sizing: border-box;
		width: 100%;
		padding: 10px;
		padding-top: 0;

		ul {
			float: left;
			clear: both;

			width: 100%;
			margin-top: 10px;
			padding: 0;
			border-bottom: 1px solid rgba(var(--global-text), 0.4);

			li {
				float: left;
				clear: both;

				width: 100%;
				padding: 0;
				border-top: 1px solid rgba(var(--global-text), 0.4);

				list-style-type: none;

				.${ButtonRoot.base} {
					float: left;
					width: 100%;

					span {
						height: auto;
						padding: 0 5px;
					}
				}
			}
		}
	`,
};
